// src/components/admin/CategoryDialog.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { translations } from '../../utils/translations';

const CategoryDialog = ({ category, onClose, onSubmit }) => {
  const { language } = useApp();
  const t = translations[language];
  
  const [formData, setFormData] = useState({
    name: category?.name || '',
    name_en: category?.name_en || '',
    name_km: category?.name_km || ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const isEdit = !!category;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-md">
        <div className="border-b p-6 flex justify-between items-center">
          <h3 className="text-xl font-bold">
            {isEdit 
              ? (language === 'en' ? 'Edit Category' : language === 'km' ? 'កែសម្រួលប្រភេទ' : '编辑分类')
              : (language === 'en' ? 'Add Category' : language === 'km' ? 'បន្ថែមប្រភេទ' : '添加分类')}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* 中文名 */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {language === 'zh' ? '分类名称 (中文) *' : 
               language === 'en' ? 'Category Name (Chinese) *' :
               'ឈ្មោះប្រភេទ (ចិន) *'}
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="饮料"
              required
            />
          </div>

          {/* 英文名 */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {language === 'zh' ? '分类名称 (英文)' : 
               language === 'en' ? 'Category Name (English)' :
               'ឈ្មោះប្រភេទ (អង់គ្លេស)'}
            </label>
            <input
              type="text"
              value={formData.name_en}
              onChange={(e) => setFormData({...formData, name_en: e.target.value})}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Beverages"
            />
          </div>

          {/* 高棉语名 */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {language === 'zh' ? '分类名称 (高棉语)' : 
               language === 'en' ? 'Category Name (Khmer)' :
               'ឈ្មោះប្រភេទ (ខ្មែរ)'}
            </label>
            <input
              type="text"
              value={formData.name_km}
              onChange={(e) => setFormData({...formData, name_km: e.target.value})}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="ភេសជ្ជៈ"
            />
          </div>

          {/* 按钮 */}
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              {t.cancel}
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              {isEdit ? t.save : t.confirm}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryDialog;